import ExcelJS from 'exceljs';
import companyLogo from '../assets/company-logo.png';
import { getAuthHeaders } from '../utils/authHeaders';

const API_URL = 'https://app.pvslimited.co.uk/api';

const FONT_ARIAL = 'Arial';
const LIGHT_GREY_FILL = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEEEEEE' } };
const ALT_ROW_FILL = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };

const sendCertificationEmail = async (formData) => {
  const createExcelData = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Tank Certification', { properties: {
      defaultRowHeight: 25
    }
    });

    worksheet.views = [{ showGridLines: false }];

    worksheet.pageSetup = {
      paperSize: 9,
      orientation: 'landscape',
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 0,
      margins: {
        left: 0.08,
        right: 0.08,
        top: 0.08,
        bottom: 0.08,
        header: 0.08,
        footer: 0.08
      }
    };

    worksheet.columns = [
      { width: 41 },
      { width: 30 },
      { width: 55 },
      { width: 10 },
      { width: 35 },
      { width: 10 },
    ];

    worksheet.spliceRows(1, 0, ['']);
    worksheet.getRow(1).height = 30;

    try {
      const response = await fetch(companyLogo);
      const imageBuffer = await response.arrayBuffer();
      
      const logoId = workbook.addImage({
          buffer: imageBuffer,
          extension: 'png',
      });
  
          worksheet.addImage(logoId, {
              tl: { col: 0, row: 0 },
              ext: { width: 286, height: 288 }
          });
          worksheet.addRow([]);
 
    } catch (error) {
      console.error('Error adding logo:', error);
    const pvsRow = worksheet.addRow(['PVS']);
    pvsRow.getCell(1).font = {
      name: FONT_ARIAL,
      size: 24,
      bold: true,
      color: { argb: 'FF32CD32' }
    };
    worksheet.mergeCells(`A${pvsRow.number}:B${pvsRow.number}`);
    
    const servicesRow = worksheet.addRow(['Pressure Vessel Services']);
    servicesRow.getCell(1).font = {
      name: FONT_ARIAL,
      size: 16,
      bold: true,
      color: { argb: 'FF32CD32' }
    };
    worksheet.mergeCells(`A${servicesRow.number}:B${servicesRow.number}`);
  }
 
  const titleRow = worksheet.addRow(['BULK TANK THOROUGH EXAMINATION CERTIFICATE']);
  worksheet.mergeCells(`A${titleRow.number}:F${titleRow.number}`);
  titleRow.getCell(1).font = {
    name: FONT_ARIAL,
    size: 18,
    bold: true,
    underline: 'double'
  };
  titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

  const examRow = worksheet.addRow(['EXAMINED IN ACCORDANCE WITH UKLPG CODE OF PRACTICE 1 PART 3 2022']);
  worksheet.mergeCells(`A${examRow.number}:F${examRow.number}`);
  examRow.getCell(1).font = {
    name: FONT_ARIAL,
    size: 14,
    underline: 'double'
  };
  examRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };

  const refRow = worksheet.addRow(['Ref: PVS-TCF-001 | Version: 1.0']);
  worksheet.mergeCells(`A${refRow.number}:F${refRow.number}`);
  refRow.getCell(1).font = { name: FONT_ARIAL, size: 9, color: { argb: 'FF888888' } };
  refRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };

  worksheet.addRow([]);
  worksheet.addRow([]);

  const dataRows = [
    ['Certificate Number:', data.certificateNumber, 'Relief Valve Pressure', data.pressureSettings],
    ['Customer Name:', data.customerName, 'Relief Valve Type', data.reliefValveType],
    ['Preparation Depot:', data.preparationDepot, 'Relief Valve Details', data.reliefValveDetails],
    ['Telephone', data.telephone, 'Design Temperature', data.designTemperature],
    ['Examination Type', data.examinationType, 'Torque Wrench Used', data.torqueWrenchUsed || 'N/A'],
    ['Date of Examination:', data.examinationDate, 'This vessel will require a test in', data.nextTestYear],
    ['Manufacturer:', data.manufacturer],
    ['Date of Manufacture:', data.dateOfManufacture],
    ['Name Plate Stamped:', data.namePlateStamped, 'External Surfaces & Welds Examined:', data.externalSurfacesExamined ? 'Yes' : 'No'],
    ['Previous Test Date:', data.previousTestDate, 'Fixed Liquid Level Checked:', data.fixedLiquidLevelChecked ? 'Yes' : 'No'],
    ['Vessel Serial Number:', data.vesselSerialNumber, 'Vapour Off Take Valve Operational:', data.vapourOffTakeValveChecked ? 'Yes' : 'No'],
    ['Water Capacity:', data.waterCapacity, 'Valves & Fittings Checked/Replaced:', data.allValvesChecked ? 'Yes' : 'No'],
    ['Color:', data.color, 'Vessel Pressure Tested:', data.pressureTest ? 'Yes' : 'No'],
    ['Design Code:', data.designCode, 'Paint Work Thickness Checked:', data.paintworkExamined ? 'Yes' : 'No'],
    ['Design Pressure:', data.designPressure, 'Paint Work Visually Inspected', data.paintworkVisual ? 'Yes' : 'No'],
    ['Liquid Off Take Date:', data.liquidOffTakeDate, 'Guage Operational Check', data.contentsOp ? 'Yes' : 'No'],
    ['Fill Valve Date:', data.fillValveDate, 'Identity Tag Or Sticker Installed:', data.idSticker ? 'Yes' : 'No'],
    ['Vapour Valve Date:', data.vapourValveDate, 'Valve Layout:', data.valveLayout],
    ['Relief Valve Date:', data.reliefValveDate, 'Liquid Offtake Position:', data.liquidOfftakePosition],
    ['PRVA Date:', data.PRVADate],
  ];
 
  dataRows.forEach((row, idx) => {
    const newRow = worksheet.addRow(row);

    if (idx % 2 === 1) {
      for (let c = 1; c <= 6; c++) {
        newRow.getCell(c).fill = ALT_ROW_FILL;
      }
    }

    newRow.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 12 };
    newRow.getCell(2).font = { name: FONT_ARIAL, bold: false, size: 12 };
    newRow.getCell(2).alignment = { horizontal: 'left' };
    if (row.length > 2) {
        newRow.getCell(3).font = { name: FONT_ARIAL, bold: true, size: 12 };
        newRow.getCell(4).font = { name: FONT_ARIAL, bold: false, size: 12 };
        newRow.getCell(4).alignment = { horizontal: 'left' };
    }
  });

  worksheet.addRow([]);

if (data.examinationType && data.examinationType.toLowerCase().includes('thorough')) {
    const thoroughRow = worksheet.addRow(['']);
    worksheet.mergeCells(`A${thoroughRow.number}:F${thoroughRow.number}`);
    const thoroughCell = thoroughRow.getCell(1);
    thoroughCell.value = 'Fully refurbished tank, pneumatically tested, shot blasted and painted with a zinc base coat and a coloured top coat to a minimum depth of 200 microns. Concluding with a Ultrasonic NDT inspection.';
    thoroughCell.font = { name: FONT_ARIAL, italic: true, bold: true, size: 12 };
    thoroughCell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
    thoroughRow.height = 50;
}

  const NDTtitle = worksheet.addRow(['Ultrasonic NDT Readings']);
  worksheet.mergeCells(`A${NDTtitle.number}:F${NDTtitle.number}`);
  NDTtitle.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 14, underline:'double'};
  NDTtitle.getCell(1).alignment = { 
    wrapText: true,
    vertical: 'middle',
    horizontal: 'center' };
  for (let c = 1; c <= 6; c++) {
    NDTtitle.getCell(c).fill = LIGHT_GREY_FILL;
  }

    const NDTparagraph = worksheet.addRow(['All results in millimeters recorded to the nearest 0.1 mm. Results 1,3,4,8,9,13,14,19,20,21,22,23,29,30,31 & 32 should be taken 25 mm from the adjacent weld. If there is evidence of corrosion additional readings should be taken in the corroded area. If a reading is considerably different from other readings retake the reading. If the reading exceeds 10% of the control value the vessel test will be rejected.']);
    NDTparagraph.height = 50;
    worksheet.mergeCells(`A${NDTparagraph.number}:F${NDTparagraph.number}`);
    
    const ndtParaCell = worksheet.getCell(`A${NDTparagraph.number}`);
    ndtParaCell.font = { name: FONT_ARIAL, italic: true, size: 12 };
    ndtParaCell.alignment = {
        wrapText: true,
        vertical: 'middle',
        horizontal: 'center'
    };

const shellTitlesRow = worksheet.addRow(['NDT Readings - Main Shell', '', 'NDT Readings - End Shell 1', '', 'NDT Readings - End Shell 2']);
shellTitlesRow.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 12, underline: 'single' };
shellTitlesRow.getCell(3).font = { name: FONT_ARIAL, bold: true, size: 12, underline: 'single' };
shellTitlesRow.getCell(5).font = { name: FONT_ARIAL, bold: true, size: 12, underline: 'single' };

shellTitlesRow.getCell(1).alignment = { horizontal: 'left' };
shellTitlesRow.getCell(3).alignment = { horizontal: 'left' };
shellTitlesRow.getCell(5).alignment = { horizontal: 'left' };

for (let c = 1; c <= 6; c++) {
  shellTitlesRow.getCell(c).fill = LIGHT_GREY_FILL;
}

worksheet.mergeCells(`A${shellTitlesRow.number}:B${shellTitlesRow.number}`);
worksheet.mergeCells(`C${shellTitlesRow.number}:D${shellTitlesRow.number}`);
worksheet.mergeCells(`E${shellTitlesRow.number}:F${shellTitlesRow.number}`);

const controlReadingsRow = worksheet.addRow([
    'Control Reading:',
    data.controlReadings?.mainShell || 'N/A',
    'Control Reading:',
    data.controlReadings?.endShell1 || 'N/A',
    'Control Reading:',
    data.controlReadings?.endShell2 || 'N/A'
]);
controlReadingsRow.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 12 };
controlReadingsRow.getCell(2).font = { name: FONT_ARIAL, bold: false, size: 12 };
controlReadingsRow.getCell(3).font = { name: FONT_ARIAL, bold: true, size: 12 };
controlReadingsRow.getCell(4).font = { name: FONT_ARIAL, bold: false, size: 12 };
controlReadingsRow.getCell(5).font = { name: FONT_ARIAL, bold: true, size: 12 };
controlReadingsRow.getCell(6).font = { name: FONT_ARIAL, bold: false, size: 12 };
controlReadingsRow.getCell(1).alignment = { horizontal: 'left' };
controlReadingsRow.getCell(2).alignment = { horizontal: 'left' };
controlReadingsRow.getCell(3).alignment = { horizontal: 'left' };
controlReadingsRow.getCell(4).alignment = { horizontal: 'left' };
controlReadingsRow.getCell(5).alignment = { horizontal: 'left' };
controlReadingsRow.getCell(6).alignment = { horizontal: 'left' };

for (let i = 0; i < 19; i++) {
  const row = worksheet.addRow([
      `Reading ${i + 1}:`,
      data.readings[i],
      i < 10 ? `Reading ${i + 20}:` : '',
      i < 10 ? data.readings[i + 19] : '',
      i < 10 ? `Reading ${i + 30}:` : '',
      i < 10 ? data.readings[i + 29] : ''
  ]);

  if (i % 2 === 1) {
    for (let c = 1; c <= 6; c++) {
      row.getCell(c).fill = ALT_ROW_FILL;
    }
  }
  
  row.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 12 };
  row.getCell(2).font = { name: FONT_ARIAL, bold: false, size: 12 };
  row.getCell(1).alignment = { horizontal: 'left' };
  row.getCell(2).alignment = { horizontal: 'left' };
  
  if (i < 10) {
      row.getCell(3).font = { name: FONT_ARIAL, bold: true, size: 12 };
      row.getCell(3).alignment = { horizontal: 'left' };
      row.getCell(4).font = { name: FONT_ARIAL, bold: false, size: 12 };
      row.getCell(4).alignment = { horizontal: 'left' };
      row.getCell(5).font = { name: FONT_ARIAL, bold: true, size: 12 };
      row.getCell(5).alignment = { horizontal: 'left' };
      row.getCell(6).font = { name: FONT_ARIAL, bold: false, size: 12 };
      row.getCell(6).alignment = { horizontal: 'left' };
  }
}

if (data.additionalShells && data.additionalShells.length > 0) {
  worksheet.addRow([]);
  data.additionalShells.forEach((shell, shellIndex) => {
    const addShellTitle = worksheet.addRow([`NDT Readings - Additional Shell ${shellIndex + 1}`]);
    worksheet.mergeCells(`A${addShellTitle.number}:B${addShellTitle.number}`);
    addShellTitle.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 12, underline: 'single' };
    addShellTitle.getCell(1).alignment = { horizontal: 'left' };
    for (let c = 1; c <= 6; c++) {
      addShellTitle.getCell(c).fill = LIGHT_GREY_FILL;
    }

    const controlRow = worksheet.addRow(['Control Reading:', shell.controlReading || 'N/A']);
    controlRow.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 12 };
    controlRow.getCell(2).font = { name: FONT_ARIAL, bold: false, size: 12 };
    controlRow.getCell(2).alignment = { horizontal: 'left' };

    for (let i = 0; i < 19; i++) {
      const row = worksheet.addRow([`Reading ${i + 1}:`, shell.readings[i] || '']);
      row.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 12 };
      row.getCell(2).font = { name: FONT_ARIAL, bold: false, size: 12 };
      row.getCell(1).alignment = { horizontal: 'left' };
      row.getCell(2).alignment = { horizontal: 'left' };
      if (i % 2 === 1) {
        for (let c = 1; c <= 6; c++) {
          row.getCell(c).fill = ALT_ROW_FILL;
        }
      }
    }
    worksheet.addRow([]);
  });
}

worksheet.addRow([]);
const examinerRowNum = worksheet.rowCount + 1;
const examinerRow = worksheet.getRow(examinerRowNum);
examinerRow.getCell(1).value = 'Examiner:';
examinerRow.getCell(2).value = data.examinerName;
examinerRow.getCell(1).font = { name: FONT_ARIAL, bold: true, size: 16 };
examinerRow.getCell(2).font = { name: FONT_ARIAL, bold: false, size: 16 };
examinerRow.getCell(1).alignment = { horizontal: 'left', vertical:'top' };
examinerRow.getCell(2).alignment = { horizontal: 'left', vertical:'top' };

examinerRow.getCell(3).value = 'Date:';
examinerRow.getCell(4).value = data.signatureDate;
examinerRow.getCell(3).font = { name: FONT_ARIAL, bold: true, size: 16 };
examinerRow.getCell(4).font = { name: FONT_ARIAL, bold: false, size: 16 };
examinerRow.getCell(3).alignment = { horizontal: 'left', vertical: 'top' };
examinerRow.getCell(4).alignment = { horizontal: 'left', vertical:'top'};
examinerRow.height = 35;

const lastRow = worksheet.rowCount;
const lastCol = 6;

for (let row = 1; row <= lastRow; row++) {
    for (let col = 1; col <= lastCol; col++) {
        const cell = worksheet.getCell(row, col);
        
        if (!cell.border) {
            cell.border = {};
        }

        if (row === 1) {
            cell.border.top = { 
                style: 'thick', 
                color: { argb: 'FF0437F2' }
            };
        }
        if (row === lastRow) {
            cell.border.bottom = { 
                style: 'thick', 
                color: { argb: 'FF0437F2' }
            };
        }
        if (col === 1) {
            cell.border.left = { 
                style: 'thick', 
                color: { argb: 'FF0437F2' }
            };
        }
        if (col === lastCol) {
            cell.border.right = { 
                style: 'thick', 
                color: { argb: 'FF0437F2' }
            };
        }
    }
}

worksheet.getRow(worksheet.rowCount).height = 48;
worksheet.getRow(1).height = 75;
worksheet.getRow(lastRow).height = 48;

    const buffer = await workbook.xlsx.writeBuffer();
    console.log('Excel file created with styling');
    return buffer;
  };

  try {
    console.log('Starting email process');
    const excelBuffer = await createExcelData(formData);
    console.log('Excel buffer created');

    const blob = new Blob([excelBuffer], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    console.log('Created blob');

    const formDataToSend = new FormData();

    formDataToSend.append('file', blob, 'tank-certification.xlsx');
    formDataToSend.append('to', 'forms@pvslimited.com');
    formDataToSend.append('subject', `Tank Certification Form ${formData.vesselSerialNumber}`);
    console.log('FormData prepared');

    const response = await fetch(`${API_URL}/send-email-with-attachment`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formDataToSend
    });
    console.log('Fetch response:', response.status);

    if (!response.ok) throw new Error('Failed to send email');
    return true;
  } catch (error) {
    console.error('Email sending failed:', error);
    return false;
  }
};

export default sendCertificationEmail;
